"use client";

import type { LatLng } from "@components/store-locator/humanize-distance";
import { useGetUserPosition } from "@hooks/useGetUserPosition";
import { getUserPositionCoords } from "@lib/utils/getUserPositionCoords";
import { useCallback, useState } from "react";

export const useClientLocation = (isEnabled: boolean) => {
    const [clientLocation, setClientLocation] = useState<LatLng | null>(null);

    const successCallback = useCallback((position: GeolocationPosition) => {
        setClientLocation(getUserPositionCoords(position));
    }, []);

    const errorCallback = useCallback(() => {
        setClientLocation(null);
    }, []);

    useGetUserPosition({
        isEligible: isEnabled,
        successCallback,
        errorCallback,
    });

    return clientLocation;
};
